
export const SET_SERVICE = "SET_SERVICE"
export const SET_EDIT_SERVICE = "SET_EDIT_SERVICE"
export const SET_UPDATE = "SET_UPDATE"
export const GET_SERVICES = "GET_SERVICES"
export const GET_DETAILS_SERVICES = "GET_DETAILS_SERVICES"
export const GET_ALL_ORDERS = "GET_ALL_ORDERS"
export const SET_MDF = "SET_MDF"
export const SET_IDGROUP = "SET_IDGROUP"
export const SET_NAME = "SET_NAME"


import config from "../../constants/config"

import FormData from "form-data"
import axios from "axios";

const baseURL="https://npln.ir/api/v1"







export const getAllService = (access_token,
    offset,
    Ostan,
    City,
    ActService,
    lowActwork,
    name

) => {

    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };

        const url = "https://npln.ir/api/v1/app/services?page=" + offset + "city_id=" + City + "&state_id=" + Ostan + "&down=" + lowActwork + "&status=" + ActService + "&name=" + name;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_SERVICES, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const getDetailsService = (access_token, ids) => {

    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/single-services?services_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_DETAILS_SERVICES, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};

















export const Setservice = (access_token,
    id,
    namemdf,
    services,
    customer,

    send,
    stutus,

    wood_type,
    wood_thickness,
    width,
    height,
     panel_description,
    Radio1,
    Radio2,
    Radio3,
   

) => {

    return async (dispatch) => {



        const Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }
       
        
        var formdata = new FormData();
        formdata.append("services_id", id);
        formdata.append("name", namemdf);
        formdata.append("sheet_status_services", services);
        formdata.append("sheet_status_customer", customer);
        formdata.append("send_status", send);
        formdata.append("status", stutus);

        formdata.append("wood_type", wood_type);
        formdata.append("wood_thickness", wood_thickness);
        formdata.append("panel_width", width);
        formdata.append("panel_height", height);
        formdata.append("panel_description", panel_description);
        formdata.append("color_strip", Radio1);
        formdata.append("width_strip", Radio2);
        formdata.append("height_strip", Radio3);
        



        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/set-services", requestOptions)
            .then(response => response.json())
            .then(res => {
                //console.log(res);

                const data = res
                dispatch({ type: SET_SERVICE, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}


export const SetEDITservice = (access_token,
    id,
    id_group,

    services,
    customer,
    namemdf,
    send,
    stutus,

    wood_type,
    wood_thickness,
    width,
    height,
    
    color_strip,
    width_strip,
    height_strip,
    panel_description,
) => {

    return async (dispatch) => {


      
        const Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }


        var formdata = new FormData();
        formdata.append("order_id", id);
        formdata.append("order_group_id", id_group);

        formdata.append("sheet_status_services", services);
        formdata.append("sheet_status_customer", customer);
        formdata.append("name", namemdf);
        formdata.append("send_status", send);
        formdata.append("status", stutus);

        formdata.append("wood_type", wood_type);
        formdata.append("wood_thickness", wood_thickness);
        formdata.append("panel_width", width);
        formdata.append("panel_height", height);

        

        formdata.append("color_strip", color_strip);
        formdata.append("width_strip", width_strip);
        formdata.append("height_strip", height_strip);
        formdata.append("panel_description", panel_description);
        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/edit", requestOptions)
            .then(response => response.json())
            .then(res => {
                // console.log(res);

                const data = res
                dispatch({ type: SET_EDIT_SERVICE, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}






export const SetserviceChat = (access_token,
    id,
    namemdf
    , send,
    services,
    customer

) => {
    const Header = {
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
    }

    var formdata = new FormData();
    formdata.append("services_id", id);
    formdata.append("name", namemdf);
    formdata.append("send_status", send);
    formdata.append("sheet_status_services", services);
    formdata.append("sheet_status_customer", customer);
    formdata.append("status", "send");
    formdata.append("class", "chat");


    var requestOptions = {
        method: 'POST',
        headers: Header,
        body: formdata,
    };

    return fetch("https://npln.ir/api/v1/order/set-services", requestOptions)
        .then(response => response.json())
        .then(res => {
            //  console.log(res);



            return res;
        })

        .catch(error => console.log('error', error));
};





// export const SetserviceChat = (access_token, id,
//     namemdf
//     ,send,
//     typesend) => {



//         const Header = {
//             Accept: "application/json",
//             Authorization: "Bearer " + access_token,
//         };


//         const formdata = new FormData();
//         formdata.append("services_id", id);
//         formdata.append("name", namemdf);
//         formdata.append("send_status", send);
//         formdata.append("sheet_status", typesend);
//         formdata.append("class", "chat");
//         const url = "https://npln.ir/api/v1/order/set-services";
//         return axios({
//             method: "POST",
//            headers: Header,
//             url: url,
//             data:formdata
//         })

//             .then(function (response) {
//                 //console.log(response);

//                 return response;
//             })
//             .catch(function (error) {
//                 console.log(error.name);
//                 console.log(error.message);
//                 console.log(error);
//             });
//     };




















export const UpdateOrder = (access_token,
    id,

) => {

    return async (dispatch) => {


        const Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }

        var formdata = new FormData();
        formdata.append("order_id", id);



        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/status-order", requestOptions)
            .then(response => response.json())
            .then(res => {
                // console.log(res);

                const data = res
                dispatch({ type: SET_UPDATE, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}




export const SendName = (access_token,
    id,name

) => {

    return async (dispatch) => {


        const Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }

        var formdata = new FormData();
        formdata.append("order_id", id);
        formdata.append("name", name);



        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/edit", requestOptions)
            .then(response => response.json())
            .then(res => {
                // console.log(res);

                const data = res
                dispatch({ type: SET_NAME, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}




export const getAllOrder = (access_token, offset, name,stutus) => {

    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };

    //    console.log( name);
        const url = "https://npln.ir/api/v1/order/orders?page=" + offset + "&search=" + name +"&status=" + stutus;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_ALL_ORDERS, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const GetTypeMdf = (data) => {
    return async (dispatch) => {
        dispatch({ type: SET_MDF, data });
    };
};

export const GetIDgroup = (data) => {
    return async (dispatch) => {
        dispatch({ type: SET_IDGROUP, data });
    };
};
